import { PulseLoader } from 'react-spinners'

const Loader = ({ size }) => {
	return <PulseLoader size={size ? size : 12} color={'#efbd65'} />
}

export default Loader
